import {
  Field,
  FieldDescription,
  FieldGroup,
  FieldLabel,
  FieldSet,
} from "@/client/components/shad/field";
import { adsbWebsocket, WebsocketConnect } from ".";
import { Suspense } from "react";
import { Skeleton } from "@/client/components/shad/skeleton";
import { Separator } from "@/client/components/shad/separator";
import {
  CodeBlock,
  CodeBlockSnippet,
} from "@/client/components/common/CodeBlock";

export const SkopaDoc = () => {
  return (
    <FieldSet className="mt-5">
      <FieldGroup>
        <Field>
          <FieldLabel>Connect to Zeus UI Connect</FieldLabel>
          <FieldDescription>Send Websocket messages to</FieldDescription>

          <Suspense fallback={<Skeleton className="w-full h-96 rounded-md" />}>
            <CodeBlock>
              <CodeBlockSnippet code={WebsocketConnect} />
            </CodeBlock>
          </Suspense>
        </Field>
        <Separator />
        <Field>
          <FieldLabel>ADSB Websocket example</FieldLabel>
          <FieldDescription>
            See example of web socket connect for adding targets to the map
          </FieldDescription>

          <Suspense fallback={<Skeleton className="w-full h-96 rounded-md" />}>
            <CodeBlock>
              <CodeBlockSnippet code={adsbWebsocket} />
            </CodeBlock>
          </Suspense>
        </Field>
      </FieldGroup>
    </FieldSet>
  );
};
